module.exports = __webpack_public_path__ + "img/login-talleres.753954f4.jpg";